import { create } from 'zustand';
import { Service } from './servicesService';

interface ServicesStore {
	services: Service[];
	servicesByIds: Service[];
	setServices: (services: Service[]) => void;
	setServicesByIds: (servicesByIds: Service[]) => void;
}

export const useServicesStore = create<ServicesStore>((set) => ({
	services: [],
	servicesByIds: [],
	setServices: (services) => set({ services }),
	setServicesByIds: (servicesByIds) => set({ servicesByIds }),
}));
